import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { FORGET_PASSWORD } from "./actionTypes"
import { userForgetPasswordSuccess, userForgetPasswordError } from "./actions"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeForgetPwd,
  postJwtForgetPwd,
} from "../../../helpers/fakebackend_helper"

const fireBaseBackend = getFirebaseBackend()

interface ForgetPasswordAction {
  type: string;
  payload: {
    user: {
      email: string;
      [key: string]: any;
    };
    history: any;
  };
}

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* forgetUser(action: ForgetPasswordAction): Generator<any, void, any> {
  const { payload: { user } } = action;
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      if (fireBaseBackend) {
        const response = yield call(fireBaseBackend.forgetPassword.bind(fireBaseBackend) as any, user.email)
        if (response) {
          yield put(
            userForgetPasswordSuccess(
              "Reset link are sended to your mailbox, check there first"
            )
          )
        }
      }
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtForgetPwd as any, "/jwt-forget-pwd", {
        email: user.email,
      })
      if (response) {
        yield put(
          userForgetPasswordSuccess(
            "Reset link are sended to your mailbox, check there first"
          )
        )
      }
    } else {
      const response = yield call(postFakeForgetPwd as any, "/fake-forget-pwd", {
        email: user.email,
      })
      if (response) {
        yield put(
          userForgetPasswordSuccess(
            "Reset link are sended to your mailbox, check there first"
          )
        )
      }
    }
  } catch (error) {
    yield put(userForgetPasswordError(error))
  }
}

export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser)
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget)])
}

export default forgetPasswordSaga
